import { ModalOptions, modalController } from '@ionic/core';

export async function showSubscribeModal(onDidDismiss?: () => void) {
  const modalCtrl = modalController;
  const modalOptions: ModalOptions = {
    component: 'ion-nav',
    backdropDismiss: false,
    componentProps: {
      root: 'sw-subscribe-page',
      rootParams: {
        //@todo don't use global modal control as a ui layout modifier, replace with boolean
        modalCtrl,
      },
    },
  };
  const modal = await modalCtrl.create(modalOptions);
  await modal.present();
  if (onDidDismiss) {
    await modal.onDidDismiss();
    onDidDismiss();
    console.debug('dismissed subscribe modal');
  }
}
